import React from "react";
import axios from "axios";
import {
  BASE_URL,
  ORDERS,
  HEADERS,
  CURRENTUSER,
  REGIONS,
  ADMIN,
  DRIVERS,
  PAYMENT,
  SHOPS,
} from "../../common/api";
import "../../assets/order.css";
import { Form } from "react-bootstrap";
import Pagination from "../../common/pagination";
import Select from "react-select";

const orderStatus = [
  { value: 0, label: "Открыто" },
  { value: 1, label: "Принято" },
  { value: 2, label: "В процессе" },
  { value: 3, label: "В пути" },
  { value: 4, label: "Доставлено" },
  { value: 5, label: "Отменено" },
  { value: 6, label: "Отклонено" },
];

const deliveryStatus = [
  { value: "Waiting", label: "Ожидание" },
  { value: "Delivery attached", label: "Доставщик прикреплен" },
  { value: "Delivery accepted", label: "Доставщик принял" },
  { value: "Client accepted", label: "Клиент принял" },
  { value: "Client rejected", label: "Клиент отклонил" },
];

const paymentStatus = [
  { value: 0, label: "Не оплачено" },
  { value: 1, label: "Оплачено терминалом" },
  { value: 2, label: "Оплачено доставщику" },
];

export default class Order extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      items: [],
      filters: {},
      currentPage: 1,
      totalPages: 1,
    };
    this.overallPrice = 0;
    this._isMounted = false;
  }

  currencyFormat = (num) => {
    return num.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
  };

  edit = (id) => {
    this.props.history.push(`/single-order/${id}/1`);
  };

  handleFilter = (event, stateVariable, selectType = 0) => {
    const updateFilters = () => {
      const { filters } = this.state;
      const queryString = Object.entries(filters)
        .reduce((acc, [key, value]) => {
          if (value !== "") {
            // Check for empty strings
            return [...acc, `${key}=${value}`];
          }
          // If the value is an empty string, skip this filter
          return acc;
        }, [])
        .join("&");
      this.props.history.push(`?${queryString}`);
      // Remove the filters that have an empty string value
      const filteredFilters = Object.fromEntries(
        Object.entries(filters).filter(([key, value]) => value !== "")
      );
      this.setState({ filters: filteredFilters });
    };

    if (selectType === 2) {
      const value = event ? event.value : "";
      this.setState(
        {
          filters: {
            ...this.state.filters,
            [stateVariable]: value,
          },
        },
        updateFilters
      );
    } else {
      this.setState(
        {
          filters: {
            ...this.state.filters,
            [stateVariable]: event.target.value,
          },
        },
        updateFilters
      );
    }
  };

  handlePageChange(pageNumber) {
    this.setState({
      currentPage: pageNumber,
    });
    this.getData(pageNumber);
  }

  getData = (pageNumber = 1) => {
    this._isMounted = true;

    this._isMounted &&
      axios
        .get(
          BASE_URL + ORDERS + `?page=${pageNumber}`,
          { params: this.state.filters },
          HEADERS
        )
        .then((res) => {
          const orders = res.data.results;
          this.setState({
            orders: orders,
            totalPages: Math.ceil(res.data.count / 20),
          });
        }, () => {console.log(this.state.orders)});
  };

  getSelectedValues = (filterProp, stateProp) => {
    const { filters } = this.state;
    const selectedValues =
      filters[filterProp] && filters[filterProp].split(",").map(Number);
    const arr = [];
    selectedValues &&
      selectedValues.map((el) => {
        const exist = this.state[stateProp].find((col) => col.value == el);
        return arr.push(exist);
      });
    return arr.length ? arr : [];
  };

  async componentDidMount() {
    this._isMounted = true;
    this.getData();
    await axios.get(BASE_URL + CURRENTUSER, HEADERS).then((res) => {
      const regions = res.data.regions;
      const filterRegions = regions.join(",");
      this.setState({
        filters: {
          ...this.state.filters,
          region: filterRegions,
        },
      });
    });
    this._isMounted &&
      axios.get(BASE_URL + REGIONS, HEADERS).then((res) => {
        const arr = [];
        const data = res.data;
        data.map((el) => {
          return arr.push({ value: el.id, label: el.nameRu });
        });
        this.setState({ regions: arr });
      });
    this._isMounted &&
      axios.get(BASE_URL + ADMIN, HEADERS).then((res) => {
        const arr = [];
        const data = res.data;
        data.map((el) => {
          return arr.push({
            value: el.id,
            label: `${el.first_name}  ${el.last_name}`,
          });
        });
        this.setState({ managers: arr });
      });
    this._isMounted &&
      axios.get(BASE_URL + DRIVERS, HEADERS).then((res) => {
        const arr = [];
        const data = res.data;
        data.map((el) => {
          return arr.push({
            value: el.id,
            label: `${el.first_name}  ${el.last_name}`,
          });
        });
        this.setState({ drivers: arr });
      });
    this._isMounted &&
      axios.get(BASE_URL + PAYMENT, HEADERS).then((res) => {
        const arr = [];
        const data = res.data;
        data.map((el) => {
          return arr.push({ value: el.id, label: el.title });
        });
        this.setState({ payments: arr });
      });
    this._isMounted &&
      axios.get(BASE_URL + SHOPS, HEADERS).then((res) => {
        const arr = [];
        const data = res.data;
        data.map((el) => {
          return arr.push({ value: el.id, label: el.name_ru });
        });
        this.setState({ shops: arr });
      });

    const searchParams = new URLSearchParams(window.location.search);
    const filters = {};
    for (let [key, value] of searchParams.entries()) {
      if (value === "true" || value === "false") {
        filters[key] = value === "true";
      } else if (isNaN(Number(value))) {
        filters[key] = value;
      } else {
        filters[key] = value;
      }
    }
    this.setState({ filters });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filters !== this.state.filters) {
      this.getData();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const {
      orders,
      filters,
      currentPage,
      totalPages,
      regions,
      managers,
      drivers,
      payments,
      shops,
    } = this.state;
    console.log(this.state.filters);
    return (
      <>
        <div className="filters">
          <div className="row">
            <div className="col">
              <Form.Label>Статус заказа:</Form.Label>
              <Select
                options={orderStatus}
                isClearable={true}
                placeholder="Выберите..."
                onChange={(event) =>
                  this.handleFilter(event, "order_status", 2)
                }
                defaultValue={orderStatus.find(
                  (el) => el.value == this.state.filters.order_status
                )}
              />
            </div>
            <div className="col">
              <Form.Label>Статус платежа:</Form.Label>
              <Select
                options={paymentStatus}
                isClearable={true}
                placeholder="Выберите..."
                onChange={(event) =>
                  this.handleFilter(event, "payment_status", 2)
                }
                defaultValue={paymentStatus.find(
                  (el) => el.value == this.state.filters.payment_status
                )}
              />
            </div>
            <div className="col">
              <Form.Label>Cостояние доставки:</Form.Label>
              <Select
                options={deliveryStatus}
                isClearable={true}
                placeholder="Выберите..."
                onChange={(event) =>
                  this.handleFilter(event, "delivery_status", 2)
                }
                defaultValue={deliveryStatus.find(
                  (el) => el.value == this.state.filters.delivery_status
                )}
              />
            </div>
            <div className="col">
              <Form.Label>Регион:</Form.Label>
              <Select
                options={regions}
                isClearable={true}
                placeholder="Выберите..."
                onChange={(event) => this.handleFilter(event, "region", 2)}
                defaultValue={
                  regions &&
                  regions.find((el) => el.value == this.state.filters.region)
                }
              />
            </div>
            <div className="col">
              <Form.Label>Сотрудник:</Form.Label>
              <Select
                options={managers}
                isClearable={true}
                placeholder="Выберите..."
                onChange={(event) => this.handleFilter(event, "manager", 2)}
                defaultValue={
                  managers &&
                  managers.find((el) => el.value == this.state.filters.manager)
                }
              />
            </div>
          </div>
          <div className="row pt-2">
            <div className="col">
              <Form.Label>Курьер:</Form.Label>
              <Select
                options={drivers}
                isClearable={true}
                placeholder="Выберите..."
                onChange={(event) => this.handleFilter(event, "deliver", 2)}
                defaultValue={
                  drivers &&
                  drivers.find((el) => el.value == this.state.filters.deliver)
                }
              />
            </div>
            <div className="col">
              <Form.Label>Способ оплаты:</Form.Label>
              <Select
                options={payments}
                isClearable={true}
                placeholder="Выберите..."
                onChange={(event) => this.handleFilter(event, "payment_met", 2)}
                defaultValue={
                  payments &&
                  payments.find(
                    (el) => el.value == this.state.filters.payment_met
                  )
                }
              />
            </div>
            <div className="col">
              <Form.Label>Showroom:</Form.Label>
              <Select
                options={shops}
                isClearable={true}
                placeholder="Выберите..."
                onChange={(event) => this.handleFilter(event, "showroom", 2)}
                defaultValue={
                  shops &&
                  shops.find((el) => el.value == this.state.filters.showroom)
                }
              />
            </div>
            <div className="col">
              <Form.Label>Цена (от):</Form.Label>
              <Form.Control
                type="number"
                placeholder="Вводите..."
                name="name"
                onChange={(event) => this.handleFilter(event, "price_min")}
                defaultValue={filters.price_min || ""}
              />
            </div>
            <div className="col">
              <Form.Label>Цена (до):</Form.Label>
              <Form.Control
                type="number"
                placeholder="Вводите..."
                name="name"
                onChange={(event) => this.handleFilter(event, "price_max")}
                defaultValue={filters.price_max || ""}
              />
            </div>
          </div>
          <div className="row pt-2">
            <div className="col">
              <Form.Label>От числа:</Form.Label>
              <Form.Control
                type="date"
                placeholder="Вводите"
                name="date_min"
                onChange={(event) => this.handleFilter(event, "date_min")}
                defaultValue={filters.date_min || ""}
              />
            </div>
            <div className="col">
              <Form.Label>До числа:</Form.Label>
              <Form.Control
                type="date"
                placeholder="Вводите"
                name="date_max"
                onChange={(event) => this.handleFilter(event, "date_max")}
                defaultValue={filters.date_max || ""}
              />
            </div>
            <div className="col">
              <Form.Label>Имя:</Form.Label>
              <Form.Control
                type="text"
                placeholder="Вводите"
                name="name"
                onChange={(event) => this.handleFilter(event, "name")}
                defaultValue={filters.name || ""}
              />
            </div>
            <div className="col">
              <Form.Label>ID:</Form.Label>
              <Form.Control
                type="text"
                placeholder="Вводите"
                name="id"
                onChange={(event) => this.handleFilter(event, "id")}
                defaultValue={filters.id || ""}
              />
            </div>
            <div className="col">
              <Form.Label>Номер телефона:</Form.Label>
              <Form.Control
                type="text"
                placeholder="Вводите"
                name="phone"
                onChange={(event) => this.handleFilter(event, "phone")}
                defaultValue={filters.phone || ""}
              />
            </div>
          </div>
        </div>
        <div className="orders">
          {orders &&
            orders.map((item) => (
              <div
                className="order-card"
                key={item.id}
                onClick={() => this.edit(item.id)}
              >
                <div className="customer-name">
                  {item.id}. {item.name}
                </div>
                <div className="customer-info">
                  <div className="customer-address">
                    <span className="address">
                      <i className="fa-solid fa-location-dot"></i>{" "}
                      {item.region_name}
                    </span>
                    <span className="date">
                      {new Date(item.expected_delivery_date).toLocaleDateString(
                        "ru-RU"
                      )}
                    </span>
                  </div>
                  <div className="customer-phone">{`+${item.phone}`}</div>
                </div>
                <div className="main-info">
                  <div>
                  Стоимость заказа:{" "}
                    <span className="sub-info">
                      {this.currencyFormat(String(item.price))} руб
                    </span>
                  </div>
                  <div>
                    Скидка: <span className="sub-info">0 руб</span>
                  </div>
                  <div>
                  Сумма наличных:{" "}
                    <span className="sub-info">
                      {this.currencyFormat(String(item.price))} руб
                    </span>
                  </div>
                  <div>
                  Через систему: <span className="sub-info">0 руб</span>
                  </div>
                  <div>
                  Через доставщика: <span className="sub-info">0 руб</span>
                  </div>
                </div>
                <span
                  className={`badge order-status ${
                    item.order_status !== 5 ? "badge-success" : "badge-danger"
                  }`}
                >
                  {item.status}
                </span>
              </div>
            ))}
        </div>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={(num) => this.handlePageChange(num)}
        />
      </>
    );
  }
}
